import api from './api';

// 获取所有客户
export const getCustomers = async (params = {}) => {
  try {
    console.log('尝试获取客户列表，参数:', params);
    const response = await api.get('/customers', { params });
    console.log('获取客户列表响应:', response.data);
    
    // 直接检查并返回 customers 字段
    if (response.data && response.data.customers && Array.isArray(response.data.customers)) {
      console.log('使用 customers 数组数据');
      return response.data.customers;
    }
    
    // 如果响应本身就是数组
    if (response.data && Array.isArray(response.data)) {
      console.log('响应是数组格式');
      return response.data;
    }
    
    // 如果是对象，尝试找到包含客户数据的属性
    if (response.data && typeof response.data === 'object') {
      console.log('尝试从对象中提取客户数据');
      for (const key in response.data) {
        if (Array.isArray(response.data[key])) {
          console.log(`使用 ${key} 属性中的数组数据`);
          return response.data[key];
        }
      }
    }
    
    // 如果没有匹配的格式，返回空数组
    console.warn('无法解析客户数据格式，返回空数组', response.data);
    return [];
  } catch (error) {
    console.error('获取客户列表错误:', error);
    // 返回空数组而不是抛出错误
    return [];
  }
};

// 搜索客户
export const searchCustomers = async (query) => {
  try {
    const response = await api.get('/customers/search', { params: { query } });
    
    if (response.data.success) {
      return response.data.customers;
    } else {
      throw new Error(response.data.message || '搜索客户失败');
    }
  } catch (error) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || '搜索客户失败');
    }
    throw error;
  }
};

// 获取单个客户详情
export const getCustomer = async (id) => {
  try {
    const response = await api.get(`/customers/${id}`);
    
    if (response.data.success) {
      return response.data.customer;
    } else {
      throw new Error(response.data.message || '获取客户详情失败');
    }
  } catch (error) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || '获取客户详情失败');
    }
    throw error;
  }
};

// 更新客户
export const updateCustomer = async (id, customerData) => {
  try {
    // 当id为null或undefined时，表示创建新客户
    const endpoint = id ? `/customers/${id}` : '/customers/new';
    const response = await api.put(endpoint, customerData);
    
    if (response.data.success) {
      return response.data;
    } else {
      throw new Error(response.data.message || '更新客户失败');
    }
  } catch (error) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || '更新客户失败');
    }
    throw error;
  }
};

// 删除客户
export const deleteCustomer = async (id) => {
  try {
    if (!id && id !== 0) {
      throw new Error('客户ID不能为空');
    }
    const response = await api.delete(`/customers/${id}`);
    
    if (response.data.success) {
      return response.data;
    } else {
      throw new Error(response.data.message || '删除客户失败');
    }
  } catch (error) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || '删除客户失败');
    }
    throw error;
  }
};
